var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.555,
    height: 33.945,
    viewBox: "0 0 33.555 33.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.109,0H1.444A1.443,1.443,0,0,0,.16.772a1.426,1.426,0,0,0,.114,1.5L11.508,17.891l.012.016a3.139,3.139,0,0,1,.63,1.88V32.52a1.408,1.408,0,0,0,.417,1.007,1.446,1.446,0,0,0,1.018.418,1.5,1.5,0,0,0,.566-.112l6.313-2.375a1.351,1.351,0,0,0,.941-1.331V19.786a3.141,3.141,0,0,1,.63-1.88l.012-.016L33.279,2.272a1.424,1.424,0,0,0,.114-1.5A1.442,1.442,0,0,0,32.109,0Zm0,0",
    transform: "translate(0.001 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.56d8dd2c1e711f741b51a6f9ae37e76c.svg";
export { ForwardRef as ReactComponent };